var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.pageData.viewMode === "list"
        ? _c("common-table")
        : _vm.pageData.viewMode === "info"
        ? _c("hd-form")
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }